import { useEffect, useState } from "react";
import { normalizeEther } from "../helpers/digits";
import { fetchBalance } from "wagmi/actions";
import { wrappedTokenABI } from "../helpers/wrappedTokenABI";
import { LENDING_CONTRACT_ADDRESS } from "../lib/constants";
import { getContract } from "wagmi/actions";

export const useGetOffersWithBalance = ({
  lendOffers,
  walletClient,
  checkBalance,
}) => {
  const [offers, setOffers] = useState(
    lendOffers
      ? lendOffers?.map((lendOffer) => ({ ...lendOffer, isReady: false }))
      : []
  );

  useEffect(() => {
    if (lendOffers) {
      if (!checkBalance) return setOffers(lendOffers);
      try {
        let offersWithBalance = lendOffers;

        if (offersWithBalance.length === 0) return setOffers(offersWithBalance);
        offersWithBalance = offersWithBalance.map(async (offer) => {
          const contract = getContract({
            address: offer?.paymentToken,
            abi: wrappedTokenABI,
            walletClient,
          });
          const [approvedAmount, userBalance] = await Promise.all([
            contract?.read.allowance([offer?.issuer, LENDING_CONTRACT_ADDRESS]),
            fetchBalance({
              address: offer?.issuer,
              //   chainId,
              token: offer?.paymentToken,
            }),
          ]);
          const balance = Number(userBalance?.formatted) || 0;
          const hasEnoughBalance =
            balance >= normalizeEther(offer?.borrowAmount);
          return {
            ...offer,
            balance,
            hasEnoughBalance,
            isReady: true,
            isApprovedEnough: BigInt(offer?.borrowAmount) <= approvedAmount,
          };
        });

        Promise.all(offersWithBalance).then((offersWithBalance) => {
          const sortedoffers = offersWithBalance.sort((a, b) => {
            if (a.hasEnoughBalance && !b.hasEnoughBalance) return -1;
            if (!a.hasEnoughBalance && b.hasEnoughBalance) return 1;
            if (a.hasEnoughBalance && b.hasEnoughBalance) {
              if (a.isApprovedEnough && !b.isApprovedEnough) return -1;
              if (!a.isApprovedEnough && b.isApprovedEnough) return 1;
            }
            // if (sortByPrice)
            //   return (
            //     Number(normalizeEther(b?.borrowAmount)) -
            //     Number(normalizeEther(a?.borrowAmount))
            //   );
            return 0;
          });
          setOffers(sortedoffers);
        });
      } catch (e) {
        console.log(e);
      }
    }
  }, [lendOffers /* , contract */]);

  return offers;
};
